import React from "react";
import companyLogo3 from "../Assets/img/companylogos/company-logo3.png";
import companyLogo8 from "../Assets/img/companylogos/company-logo8.png";
import companyLogo4 from "../Assets/img/companylogos/company-logo4.png";
import companyLogo7 from "../Assets/img/companylogos/company-logo7.png";
import companyLogo11 from "../Assets/img/companylogos/company-logo11.png";
import companyLogo18 from "../Assets/img/companylogos/company-logo18.png";

const MeetPartners2 = () => {
	return (
		<div>
			<div className="container p-5">
				<div className="row">
					<div className="col-lg-2 col-md-2 col-xs-4 col-sm-4 col-4">
						<img
							data-aos="fade-right"
							data-aos-duration="400"
							src={companyLogo3}
							className="img-fluid mx-auto d-block"
						/>
					</div>
					<div className="col-lg-2 col-md-2 col-xs-4 col-sm-4 col-4">
						<img
							data-aos="fade-right"
							data-aos-duration="800"
							src={companyLogo8}
							className="img-fluid mx-auto d-block"
						/>
					</div>
					<div className="col-lg-2 col-md-2 col-xs-4 col-sm-4 col-4">
						<img
							data-aos="fade-right"
							data-aos-duration="1200"
							src={companyLogo4}
							className="img-fluid mx-auto d-block"
						/>
					</div>
					<div className="col-lg-2 col-md-2 col-xs-4 col-sm-4 col-4">
						<img
							data-aos="fade-right"
							data-aos-duration="1600"
							src={companyLogo7}
							className="img-fluid mx-auto d-block"
						/>
					</div>
					<div className="col-lg-2 col-md-2 col-xs-4 col-sm-4 col-4">
						<img
							data-aos="fade-right"
							data-aos-duration="2000"
							src={companyLogo11}
							className="img-fluid mx-auto d-block"
						/>
					</div>
					<div className="col-lg-2 col-md-2 col-xs-4 col-sm-4 col-4">
						<img
							data-aos="fade-right"
							data-aos-duration="2400"
							src={companyLogo18}
							className="img-fluid mx-auto d-block"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
export default MeetPartners2;
